import type { FormControlLabelProps, CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import { CheckboxIcon } from '@noah-labs/fe-shared-ui-assets/muiSvgIcons/CheckboxIcon';
import { CheckedCheckboxIcon } from '@noah-labs/fe-shared-ui-assets/muiSvgIcons/CheckedCheckboxIcon';
import { Controller, useFormContext } from 'react-hook-form';
import type { PpDefaultListItemText } from '../lists/DefaultListItemText';
import { DefaultListItemText } from '../lists/DefaultListItemText';

export type PpCheckbox = Omit<MuiCheckboxProps, 'id' | 'name'> &
  Pick<FormControlLabelProps, 'label'> & {
    name: string;
    secondaryLabel?: React.ReactNode;
    slotProps?: PpDefaultListItemText['slotProps'];
  };

export function Checkbox({
  label,
  name,
  readOnly,
  secondaryLabel,
  slotProps,
  ...rest
}: PpCheckbox): React.ReactElement {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }): React.ReactElement => (
        <FormControlLabel
          {...field}
          disableTypography
          control={
            <MuiCheckbox
              checked={field.value}
              checkedIcon={<CheckedCheckboxIcon />}
              color="success"
              icon={<CheckboxIcon />}
              id={name}
              readOnly={readOnly}
              slotProps={{
                input: {
                  // @ts-expect-error false positive
                  'data-qa': `${name}-input`,
                },
              }}
              {...rest}
            />
          }
          label={
            <DefaultListItemText
              noWrap={false}
              primary={label}
              secondary={secondaryLabel}
              slotProps={{
                primary: slotProps?.primary,
              }}
            />
          }
          sx={{ pointerEvents: readOnly ? 'none' : 'auto' }}
        />
      )}
    />
  );
}
